<template>
  <b-card class="card-box card__indicator w-100" body-class="py-3">
    <div class="card-indicator" :class="indicatorClass"></div>

    <b-card-body body-class="p-0">
      <slot />
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'primary'
    }
  },

  computed: {
    indicatorClass() {
      return {
        [`bg-${this.variant}`]: true
      };
    }
  }
};
</script>

<style scoped lang="scss">
.card__indicator {
  max-width: 910px;
  margin: auto;
}
</style>
